import { ResourceProps } from 'ra-core';
import TelescopeExceptionShow from '../requests/TelescopeExceptionShow';
const TelescopeExceptionsResource: ResourceProps = {
  name: 'telescope/exceptions',
  show: TelescopeExceptionShow,
  list: undefined,
};

export default TelescopeExceptionsResource;
